import makeSlice from '@web/slices/banner/sliceMaker'

const slice = makeSlice({})

export default slice.reducer
